/**
 * Utility functions for pagination.
 * @param {Object} state - The state object containing pagination information.
 * @param {number} state.page - The current page number.
 * @param {number} state.pageOffset - The offset of the current page.
 * @param {number} state.totalPages - The total number of pages.
 * @param {number} state.briefingsPerPage - The number of briefings per page.
 * @returns {Object} - An object containing utility functions for pagination.
 */
export function paginationUtils(state) {
  /**
   * Go to the next page.
   * @returns {Object} - An object with updated page and pageOffset values.
   */
  const toNextPage = () => {
    return {
      nextPageOffset:
        state.page < state.totalPages
          ? state.pageOffset + state.briefingsPerPage
          : state.pageOffset,
      nextPage: state.page < state.totalPages ? state.page + 1 : state.page,
    };
  };

  /**
   * Go to the previous page.
   * @returns {Object} - An object with updated page and pageOffset values.
   */
  const toPrevPage = () => {
    return {
      prevPageOffset:
        state.page > 1
          ? state.pageOffset - state.briefingsPerPage
          : state.pageOffset,
      prevPage: state.page > 1 ? state.page - 1 : state.page,
    };
  };

  /**
   * Go to the last page.
   * @returns {Object} - An object with updated page and pageOffset values.
   */
  const toLastPage = () => {
    return {
      lastPageOffset: (state.totalPages - 1) * state.briefingsPerPage,
      lastPage: state.totalPages,
    };
  };

  /**
   * Go to the first page.
   * @returns {Object} - An object with updated page and pageOffset values.
   */
  const toFirstPage = () => {
    return { firstPageOffset: 0, firstPage: 1 };
  };

  return { toNextPage, toPrevPage, toLastPage, toFirstPage };
}
